"use strict";
/**
 * 枚举定义
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalystRating = exports.UP_DOWN_COLOR = void 0;
/**
 * 涨跌色枚举
 * 0: 红涨绿跌（中国内地习惯）
 * 1: 绿涨红跌（美国/香港习惯）
 */
exports.UP_DOWN_COLOR = {
    /** 红涨绿跌 */
    RED_UP: 0,
    /** 绿涨红跌 */
    GREEN_UP: 1
};
// 分析师总评级（细分）
var AnalystRating;
(function (AnalystRating) {
    AnalystRating[AnalystRating["RATING_SELL"] = 1] = "RATING_SELL";
    AnalystRating[AnalystRating["RATING_UNDERPERFORM"] = 2] = "RATING_UNDERPERFORM";
    AnalystRating[AnalystRating["RATING_HOLD"] = 3] = "RATING_HOLD";
    AnalystRating[AnalystRating["RATING_BUY"] = 4] = "RATING_BUY";
    AnalystRating[AnalystRating["RATING_STRONG_BUY"] = 5] = "RATING_STRONG_BUY"; // Strong Buy
})(AnalystRating || (exports.AnalystRating = AnalystRating = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOztHQUVHOzs7QUFFSDs7OztHQUlHO0FBQ1UsUUFBQSxhQUFhLEdBQUc7SUFDekIsV0FBVztJQUNYLE1BQU0sRUFBRSxDQUFDO0lBQ1QsV0FBVztJQUNYLFFBQVEsRUFBRSxDQUFDO0NBQ0wsQ0FBQztBQUlYLGFBQWE7QUFDYixJQUFZLGFBTVg7QUFORCxXQUFZLGFBQWE7SUFDckIsK0RBQWUsQ0FBQTtJQUNmLCtFQUF1QixDQUFBO0lBQ3ZCLCtEQUFlLENBQUE7SUFDZiw2REFBYyxDQUFBO0lBQ2QsMkVBQXFCLENBQUEsQ0FBQyxhQUFhO0FBQ3ZDLENBQUMsRUFOVyxhQUFhLDZCQUFiLGFBQWEsUUFNeEIifQ==